<template>
  <div>
    <div class="product-content-pane">
      <model-embed v-if="!videoShow" :src="modelSrc"></model-embed>
      <page-video
        :videoSrc="videoSrc"
        v-if="videoShow"
        ref="pageVideo"
      ></page-video>
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  //https://github.com/surmon-china/vue-awesome-swiper
  name: "ProductPage",
  props: {
    videoSrc: String,
    modelSrc: String,
    videoShow: Boolean,
  },
  data: function () {
    return {
      //videoShow: false,
    };
  },
  methods: {
    setVideoState(state) {
      this.$refs.pageVideo.setVideoState(state);
    },
  },
};
</script>

<style scoped></style>
